module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjIxNjczLjg4NSA1NzE0LjU4NyAxOC41MjkgMTAuNjgiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMDI5LjU2MyA1MzAxLjAzNykiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzQxNDA0MiIgc3Ryb2tlLXdpZHRoPSIycHgiIGQ9Ik0xMjkxOC43LDc4ODZsOC41NTgsOC41NTksOC41NTgtOC41NTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjI3My42NzIgLTc0NzEuNzQzKSIvPjwvZz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FilterCaret.svg
// module id = 81
// module chunks = 1